// This file was automatically generated from ptdata.ptImmunizations.html.
// Please don't edit this file by hand.

goog.provide('el8.template.ptdata.ptImmunizations');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.ptImmunizations.summary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((soy.$$escapeHtml(opt_data.administeredDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.administeredDate)) : ''), '  ', soy.$$escapeHtml(opt_data.vaccine.name));
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.ptImmunizations.displayQuantity = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.qty) ? soy.$$escapeHtml(opt_data.qty) + ((opt_data.qtyUnits) ? ' ' + soy.$$escapeHtml(opt_data.qtyUnits) : '') : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.ptImmunizations.noteSummary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append(soy.$$escapeHtml(opt_data.description), (opt_data.description != opt_data.vaccine.name) ? ' (' + soy.$$escapeHtml(opt_data.vaccine.name) + ')' : '');
  if (opt_data.qty) {
    output.append(' ');
    el8.template.ptdata.ptImmunizations.displayQuantity(opt_data, output);
  }
  output.append((opt_data.lotNumber) ? ', Lot Number: ' + soy.$$escapeHtml(opt_data.lotNumber) : '', (opt_data.manufacturerName) ? ', Mfr: ' + soy.$$escapeHtml(opt_data.manufacturerName) : '', (opt_data.method || opt_data.site) ? ',' + ((opt_data.method) ? ' ' + soy.$$escapeHtml(opt_data.method) : '') + ((opt_data.site) ? ' ' + soy.$$escapeHtml(opt_data.site) : '') : '');
  if (!opt_sb) return output.toString();
};
